module.exports = __webpack_public_path__ + "static/logo_oxford-1b7e2335fff6cd6fc67d9ed43271bf13.png";